import React, { Component } from 'react'
import UserIcon from '../../../images/user-3-color-64px.png'
import Styled from 'styled-components'
import { convertDate } from '../../function/function'
import LoaderGif from '../../../images/Pulse-1s-51px.gif'

const Card = Styled.div`
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #e4e4e4;
    margin-bottom: 10px;
    box-shadow: 1px 1px 1px #ccc;
`

const PageButton = Styled.button`
    padding: 4px;
    border: 1px solid #dedede;
    background: rgb(239, 241, 248);
`

class sick_mobile extends Component{

    constructor(){
        super()
        this.state = {
            page: 1,
            size: 1,
            denyConfirm: ""
        }
    }

    componentDidMount(){
        this.setSize()
    }

    componentDidUpdate(prevProps){
        if(prevProps != this.props){
            this.setSize()
        }
    }

    setSize = () => {
        let data = this.props.dataSick
        let size = data.length / 10
        this.setState({
            size: Math.ceil(size)
        })
    }

    next = () => {
        let currPage = this.state.page
        if(currPage < this.state.size)
        {
            currPage++;
            this.setState({
                page: currPage
            })
        }
    }

    prev = () => {
        let currPage = this.state.page
        if(currPage > 1){
            currPage--;
            this.setState({
                page: currPage
            })
        }
    }

    last = () => {
        this.setState({
            page: this.state.size
        })
    }

    first = () => {
        this.setState({
            page: 1
        })
    }

    render(){
        const listData = this.props.dataSick.map(dt => {
            let userApplicant = dt.userApplicant
            let name = userApplicant.userProfile.name
            console.log(dt)
            return  <Card>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                            <div style={{display: "flex", alignItems: "center"}}>
                                <img src={UserIcon} style={{width: "20px"}}/>
                                <div style={{marginLeft: "10px"}}>
                                    <div style={{fontWeight: "bold", fontSize: "12px"}}>{name}</div>
                                    <div style={{fontSize: "10px", color: "#9a9a9a", fontWeight: "bold"}}>
                                        {convertDate(dt.bookingDate)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{marginTop: "5px", fontSize: "14px", paddingLeft: "30px"}}>
                            {
                                (dt.reasonLeave != "")
                                ? dt.reasonLeave
                                : <span style={{color: "#9a9a9a"}}>No Description</span>
                            }
                        </div>
                    </Card>
        })
        
        return(
            <>
            <div id="base-sck-mbl" style={{padding: "20px"}}>
                {listData}
            </div>
            {
                (this.props.dataSick.length > 10)
                ?
                   <div id="ft-l-s-tbl" style={{width: "100%"}}>
                       <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginBottom: "30px"}}>
                           <div style={{fontSize: "11px"}}>Showing {this.state.page} of {this.state.size} pages</div>
                           <div style={{marginTop: "10px"}}>
                               <PageButton onClick={this.first}>First</PageButton>
                               <PageButton onClick={this.prev}>Prev</PageButton>
                               <PageButton style={{minWidth: "40px"}}>{this.state.page}</PageButton>
                               <PageButton onClick={this.next}>Next</PageButton>
                               <PageButton onClick={this.last}>Last</PageButton>
                           </div>
                       </div>
                   </div>
               : ""
            }
            {
                (this.props.isLoadSick)
                ?  
                    <div style={{textAlign: "center"}}>
                        <img src={LoaderGif} style={{width: "30px"}}/>
                        <div style={{fontSize: "12px", color: "#CCC"}}>Loading..</div>
                    </div>
                :   (this.props.dataSick.length == 0)
                    ?
                        <div style={{textAlign: "center", color: "#CCC", fontSize: "14px", fontWeight: "bold"}}>
                            No data leave<br/>to display
                        </div>
                    :   ""
            }
            </>
        )
    }
}

export default sick_mobile